import angular from 'angular'
import utils from 'utils'
class reportTaskTrackingCtrl {
  constructor(
    $scope,
    logger,
    httpRequest,
    initSortService,
    $timeout,
    $filter,
    $uibModal,
    sweetalert
  ) {
    // 所勾选初始的数据
    $scope.selectedRows = []
    $scope.currentUserInfo = JSON.parse(localStorage.user_info).user;
    $scope.select = {}
    $scope.treeConfig = {
        isCheckall: true,
        check: {
            //如果没有设置配置项，取默认配置
            enable: true, //显示不显示复选框
            chkboxType: { Y: '', N: '' },
        },
    }
    // 改变税款所属月份
    $scope.updateSearch = function () {
      queryInfo()
    }
    $scope.param = {
      pageNum: 1,
      pageSize: 10,
      param: {
        companyName: '', //名称
        taxNo: '', //识别号
        declarationStatus: '', //申报状态
        paymentStatus: '', //缴款状态
        acquisitionStatus: '', //发票采集状态
        cityName: '', //城市名
        departmentNo: '', //事业部
        province: '',
        regionName: '',
        state: '1',
        applyPeriod: utils.getLastMonthFirstLast().preMonth, // 时间
      },
    }
    // 监听所勾选纳税人变化
    $scope.$watch(
      'selectedRows',
      (newVal, oldVal) => {
        //   纳税人数
        $scope.taxPayerNum = newVal.length
        $scope.taxPayerAmount = 0
        angular.forEach(newVal, (item, index) => {
          $scope.taxPayerAmount += Number(item.totalTax)
        })
      },
      true
    )

    // 字典数据
    $scope.dictData = {}
    const typecodeArr = [
      'glsale_acquisition', //发票采集状态
      'glsale_fillInStatus', //申报表填入状态
      'glsale_declaration', //申报状态
      'glsale_pay', //缴款状态
      'department_no', //事业部
      'zzs_status',
      'yes_no_flag',
    ]
    httpRequest.get_dictByTypeArr(typecodeArr).then((res) => {
      $scope.dictData = $.extend($scope.dictData, res.data.value)
    })
    // 主管税局省（市）
    httpRequest.get_getAllTaxBureau(localStorage.getItem('id_token')).then((res) => {
      $scope.dictDataProvince = res.data.value
    })
    // 百丽--获取地区时两个参数都不传，获取管理城市时两个都要传--百丽接口
    httpRequest.get_getBelleRegion().then((res) => {
      $scope.belleRegionList = res.data.value
    })
    // 获取管理城市时两个都要传
    $scope.$watch('param.param.regionName', function (newVal, oldVal) {
      //重置
      if ($scope.param.param.regionName == '') {
        $scope.belleRegionCityList = []
        return
      }
      angular.forEach($scope.dictData.department_no, function (item, index) {
        if (item.enumName === $scope.param.param.departmentNo) {
          $scope.departmentNo = item.enumCode
        }
      })
      angular.forEach($scope.belleRegionList, function (item, index) {
        if (item.regionName === newVal) {
          $scope.regionNo = item.treeLevelCode
        }
      })
      let params = {
        affiliation: $scope.departmentNo,
        regionNo: $scope.regionNo,
      }
      if (params.affiliation == '' || params.regionNo == '') return
      httpRequest.get_getBelleRegion(params).then((res) => {
        $scope.belleRegionCityList = res.data.value
      })
    })

    // 发票采集
    $scope.invoiceCollection = function () {
      if (!$scope.selectedRows.length) {
        return logger.logError('请选中纳税人后操作')
      }
      try {
        angular.forEach($scope.selectedRows, function (item, index) {
          if (item.state == 0) {
            logger.logError('纳税人被禁用不允许发票采集，请检查!')
            throw new Error(true)
          }
          if (Number(item.fillInStatus) == 1) {
            logger.logError('RPA正在准备填入申报表，不允许发票采集，请检查!')
            throw new Error(true)
          }
          if (Number(item.fillInStatus) == 2 || Number(item.fillInStatus) == 3) {
            logger.logError('申报表已填入成功，不允许再发票采集，请检查!')
            throw new Error(true)
          }
        })
      } catch (e) {
        if (e) {
          return
        }
      }
      // 未填入和填入失败采集
      $scope.showCollectionDetailDialog($scope.selectedRows)
    }
    // 打开发票采集弹窗
    $scope.showCollectionDetailDialog = function (data) {
      return $uibModal.open({
        templateUrl: 'collectionDetai.html',
        controller: [
          '$scope',
          '$uibModalInstance',
          'logger',
          'items1',
          function ($scope, $uibModalInstance, logger, items1) {
            $scope.ok = () => {
              const selectedRowIdList = []
              angular.forEach(data, function (item, index, array) {
                selectedRowIdList.push(item.id)
              })
              httpRequest.post_sbTrackCollection(selectedRowIdList, false).then((res) => {
                // 90017 90018两种状态
                if (res.data.msgCode > 90000) {
                  logger.logError(res.data.message)
                  return
                }
                logger.logSuccess('数据采集成功，请等待RPA操作')
                queryInfo()
              })
              $uibModalInstance.close()
            }
            $scope.cancel = () => {
              $uibModalInstance.dismiss()
            }
          },
        ],
        backdrop: 'static',
        openedClass: 'mod-modal mod-modal-md',
        resolve: {
          items1() {},
        },
      }).result
    }
    //申报表填入
    $scope.declarationFill = function () {
      if (!$scope.selectedRows.length) {
        return logger.logError('请选中纳税人后操作')
      }
      const selectedRowIdList = []
      angular.forEach($scope.selectedRows, function (item, index, array) {
        selectedRowIdList.push(item.id)
      })
      let declareMapArr = selectedRowIdList.map(String)
      httpRequest.post_sbTrackFillIn(declareMapArr, false).then((res) => {
        if (res.data.msgCode == 90019) {
          logger.logError(res.data.message)
          return
        }
        if (res.data.msgCode == 90025) {
          logger.logError(res.data.message)
          return
        }
        logger.logSuccess(res.data.value)
        queryInfo()
      })
    }
    //申报
    $scope.declare = function () {
      if (!$scope.selectedRows.length) {
        return logger.logError('请选中纳税人后操作')
      }
      const selectedRowIdList = []
      angular.forEach($scope.selectedRows, function (item, index, array) {
        selectedRowIdList.push(item.id)
      })
      let declareMapArr = selectedRowIdList.map(String)
      httpRequest.post_sbTrackDeclare(declareMapArr, false).then((res) => {
        if (res.data.msgCode == 90020) {
          logger.logError(res.data.message)
          return
        } else if (res.data.msgCode == 90022) {
          logger.logError(res.data.message)
          return
        } else if (res.data.msgCode == 90024) {
          logger.logError(res.data.message)
          return
        }
        logger.logSuccess(res.data.value)
        queryInfo()
      })
    }
    // 打开申报弹窗
    function showCollectionDialog() {
      return $uibModal.open({
        templateUrl: 'origin-account-collect-dialog.html',
        controller: collectDialogCtrl,
        backdrop: 'static',
        openedClass: 'mod-modal mod-modal-md',
        resolve: {
          items1() {
            return $scope.selectedRows
          },
        },
      }).result
    }
    //交款
    $scope.Pay = function () {
      if (!$scope.selectedRows.length) {
        return logger.logError('请选中纳税人后操作')
      }
      let selectedRowIdList = []
      angular.forEach($scope.selectedRows, function (item, index, array) {
        selectedRowIdList.push(item.id)
      })
      let PayIdArr = selectedRowIdList.map(String)
      httpRequest.post_sbTrackPay(PayIdArr, false).then((res) => {
        if (res.data.msgCode == 90007) {
          logger.logError(res.data.message)
          return
        } else if (res.data.msgCode == 90013) {
          logger.logError(res.data.message)
          return
        }
        logger.logSuccess(res.data.value)
        queryInfo()
      })
    }
    // 重置
    $scope.reset = function () {
      $scope.param.param = {
        companyName: '', //名称
        taxNo: '', //识别号
        declarationStatus: '', //申报状态
        paymentStatus: '', //缴款状态
        acquisitionStatus: '', //发票采集状态
        cityName: '', //城市名
        departmentNo: '', //事业部
        province: '',
        regionName: '',
        state: '1',
        applyPeriod: utils.getLastMonthFirstLast().preMonth, // 时间
      }
      getUserInfo()
    }
    // 查询展开
    $scope.isFilterCollapsed = false
    $scope.customizedConfig = {
      version: 1.35,
      queryConfig: [
        {
          label: '纳税人名称',
          selected: true,
          default: true,
        },
        {
          label: '纳税人识别号',
          selected: true,
          default: true,
        },
        {
          label: '发票采集状态',
          selected: true,
          default: true,
        },
        {
          label: '申报表填入状态',
          selected: true,
          default: true,
        },
        {
          label: '申报状态',
          selected: true,
          default: true,
        },
        {
          label: '缴款状态',
          selected: true,
          default: true,
        },
        {
          label: '事业部',
          selected: true,
          default: true,
        },
        {
          label: '所属区域',
          selected: true,
          default: true,
        },
        {
          label: '管理城市',
          selected: true,
          default: true,
        },
        {
          label: '主管税局省（市）',
          selected: true,
          default: true,
        },
        {
          label: '是否开启申报',
          selected: true,
          default: true,
        },
        {
          label: '是否变更缴款状态',
          selected: false,
          default: false,
        },
        {
          label: '跟进人',
          selected: false,
          default: false,
        },
      ],
      table: [
        {
          label: '纳税人名称',
          selected: true,
          default: true,
        },
        {
          label: '纳税人识别号',
          selected: true,
          default: true,
        },
        {
          label: '事业部',
          selected: true,
          default: true,
        },
        {
          label: '所属区域',
          selected: true,
          default: true,
        },
        {
          label: '管理城市',
          selected: true,
          default: true,
        },
        {
          label: '主管税局省（市）',
          selected: true,
          default: true,
        },
        {
          label: '申报状态',
          selected: true,
          default: true,
        },
        {
          label: '缴款状态',
          selected: false,
          default: false,
        },
        {
          label: '应缴税款合计金额',
          selected: true,
          default: true,
        },
        {
          label: '城市维护建设税',
          selected: true,
          default: true,
        },
        {
          label: '教育费附加',
          selected: true,
          default: true,
        },
        {
          label: '地方教育附加',
          selected: true,
          default: true,
        },
        {
          label: '发票采集状态',
          selected: true,
          default: true,
        },
        {
          label: '申报表填入状态',
          selected: true,
          default: true,
        },
        {
          label: '应纳增值税',
          selected: true,
          default: true,
        },
        {
          label: '是否开启申报',
          selected: true,
          default: true,
        },
        {
          label: '异常信息提示',
          selected: true,
          default: true,
        },
        {
          label: '是否变更缴款状态',
          selected: false,
          default: false,
        },
        {
          label: '跟进人',
          selected: false,
          default: false,
        },
      ],
    }
    $scope.currentPage = 1 // 设置显示第一页
    $scope.maxSize = 10 // 每一叶显示记录数

    $scope.pageChanged = function () {
      // 点击页码发起查询
      queryInfo()
    }

    function queryInfo() {
      $scope.selectedRows = []
      const openLoading =
        $scope.param.pageSize >= 100
          ? window.layer.msg('正在查询，请耐心等待', {
              time: 0,
              skin: 'layer-loading-self',
              icon: 16,
              shade: 0.5,
            })
          : null
      httpRequest
        .post_sbTrackList(queryDataHandle($scope.param))
        .then((res) => {
          $scope.listData = res.data.value.list
          // 获取后台分页数据 回写分页组件
          $scope.totalItems = res.data.value.total
          $scope.param.pageNum = res.data.value.pageNum
          $scope.currentPage = ++res.data.value.prePage
          $scope.maxSize = res.data.value.pageSize
          $scope.param.pageSize = res.data.value.pageSize
        })
        .finally(() => {
          window.layer.close(openLoading)
        })
    }
    // queryInfo()
    function queryDataHandle(queryData) {
        $scope.employeeList = []
        const { selectedFollower } = $scope.select
        selectedFollower.forEach(item => {
            $scope.employeeList.push({employeeName:item.employeeName, employeeNumber:item.employeeNumber})
        });
        queryData.param.employeeList = $scope.employeeList
        return queryData
    }
    $scope.searchlist = function () {
      console.log($scope.param)
      queryInfo()
    }
    //导出
    $scope.exportExel = function exportExel() {
      let fileName = '申报任务跟踪(一般)_' + $scope.param.param.applyPeriod.replace('-', '')
      let url = `${
        host.etcloudIvatApp
      }taxdeclaration/rpaGsTask/exportList?accessToken=${localStorage.getItem('id_token')}`
      utils.file_download(
        url,
        $scope.param.param,
        'gl_tracking', //type
        'POST',
        'blob',
        fileName,
        false
      )
    }
    // 还原
    $scope.reduction = (type) => {
      if (!$scope.selectedRows.length) {
        return logger.logError('请选择数据后操作')
      }
      try {
        angular.forEach($scope.selectedRows, (item, index) => {
          if (item.declarationStatus == 2 || item.declarationStatus == 3) {
            logger.logError('申报已成功，不允许还原，请检查。')
            throw new Error('break')
          }
        })
      } catch (e) {
        // console.log(e,'跳出');
        return
      }
      let params = {
        ids: [],
        type,
      }
      for (let i = 0; i < $scope.selectedRows.length; i++) {
        params.ids.push($scope.selectedRows[i].id)
      }
      sweetalert
        .confirm(
          '还原提示',
          '确认需要对选择的数据进行还原操作，确认请点击【确定】按钮，否则点击【取消】按钮。'
        )
        .then(() => {
          httpRequest.post_reductionStatus(params).then((res) => {
            logger.logSuccess('还原成功')
            queryInfo()
          })
        })
    }
    $scope.changePaymentStatus = (status) => {
      if (!$scope.selectedRows.length) {
        return logger.logError('请选中纳税人后操作')
      }
      const idList = $scope.selectedRows.map((item) => item.id).map(String)
      if (Object.is(status, 0)) {
        return httpRequest.post_sbGlTrackChangeRpaTaskPayment({ idList, status }).then((res) => {
          logger.logSuccess('取消变更缴款状态成功')
          setTimeout(() => {
            queryInfo()
          }, 2000)
        })
      }
      sweetalert
        .confirm(
          '变更缴款状态提醒',
          '仅缴款状态为未缴款/缴款失败/待RPA缴款的数据支持变更缴款状态，其余状态的数据将自动过滤，确认需要对选择的数据进行变更缴款状态为“人工缴款成功”吗？'
        )
        .then(() => {
          httpRequest.post_sbGlTrackChangeRpaTaskPayment({ idList, status }).then((res) => {
            logger.logSuccess('变更缴款状态成功')
            setTimeout(() => {
              queryInfo()
            }, 2000)
          })
        })
    }
    function getUserInfo() {
        $scope.params = {
            pageSize: 2000,
            pageNum: 1,
            param: {
                isRoleOwner: '1', // 拥有本机构角色
                orgIdList: [JSON.parse(localStorage.user_info).org.orgId], // 所属机构
            },
        }
        httpRequest.get_getIvatEmployeeList().then((res) => {
            $scope.followerList = dataHandle(res.data.value)
            $scope.select.selectedFollower =  $scope.followerList.filter((x) => { return x.employeeName == $scope.currentUserInfo.realName})
            queryInfo()
        })
    }
    getUserInfo()
    function dataHandle(list) {
        list.forEach((el,index) => {
            el.orgId = index
            el.orgName = el.employeeName + '|' + el.employeeNumber
            if ($scope.currentUserInfo.realName == el.employeeName) {
                el.checked = true
            } else {
                el.checked = false
            }
        })
        return list
    }
  }
}
reportTaskTrackingCtrl.$inject = [
  '$scope',
  'logger',
  'httpRequest',
  'initSortService',
  '$timeout',
  '$filter',
  '$uibModal',
  'sweetalert',
]
export default reportTaskTrackingCtrl



// WEBPACK FOOTER //
// ./src/app/declaration/vatDeclarationSurcharges/reportTaskTracking/reportTaskTrackingCtrl.js